<script setup lang="ts">
import { toRefs } from "vue";

const BYPASS_PAYMENT_STATUSES = ["CANCELLED", "PLACED", "STARTED", "PROCESSED"];

const props = withDefaults(
  defineProps<{
    open: boolean;
    showSpinner: boolean;
    orderStatus: string;
  }>(),
  {
    open: false,
    showSpinner: false,
  },
);

const { open, showSpinner, orderStatus } = toRefs(props);

const emit = defineEmits<{
  (e: "onClose"): void;
  (e: "onConfirm"): void;
}>();

const onClose = () => {
  emit("onClose");
};
const onConfirm = () => {
  emit("onConfirm");
};
</script>

<template>
  <pn-modal @close="onClose" :open="open" label="Send order to printing?">
    <div :class="[{ spinner: showSpinner }]">
      <pn-spinner size="3" v-show="showSpinner" />
    </div>
    <div>
      <p class="pn-s">The order is currently {{ orderStatus }}.</p>
      <p class="pn-s">
        If there was something wrong with the original files or the order was
        never uploaded to Strålfors, you can process it now. It will be sent to
        Strålfors for printing.
      </p>
      <pn-toast
        v-if="BYPASS_PAYMENT_STATUSES.includes(orderStatus)"
        closable="false"
        appearance="warning"
        text="This order has not been paid for. Processing it now will bypass payment."
      ></pn-toast>
    </div>
    <div slot="buttons">
      <pn-button appearance="light" variant="outlined" @click="onClose"
        >No</pn-button
      >
      <pn-button @click="onConfirm">Yes</pn-button>
    </div>
  </pn-modal>
</template>
